import React, { useState } from 'react';
import { TextField ,makeStyles, Paper, Snackbar} from '@material-ui/core';
import { Button, Container, Form  } from 'react-bootstrap';
import { Alert } from '@material-ui/lab';
import ng_pillai from '../login/img/scope_logo.png'
import LoginServices from '../../services/login/LoginServices';
import { setloginSession, setUserPlaceSession, setUserSession } from '../Utils/Common';
// import AuthenticationService from '../../services/auoth/AuthenticationService';
import CryptoJS from 'crypto-js';

const useStyle =  makeStyles((theme) => ({
    formcontrol:{
      margin: theme.spacing(1),
      color:'white',
      minWidth: 250,
      maxWidth: 250,
    },
    submit:{
      margin: theme.spacing(1),
      padding:1,
      minWidth: 180,
      maxWidth: 200,
      
      '&:hover':{
        backgroundColor:"green",
        color:"white"
      }
    },
   
  }))
export default function Login(props) {
    const classes = useStyle();
    const [values, setValues] = useState({
        userName: "",
        password: "",
    });
    const [open ,setOpen] = useState(false);
    const [severity ,setSeverity] = useState('success');
    const [message ,setMessage] = useState('');
    const [loding ,setLoding] = useState(false)

   //Authntication call request
   const login = () => {
    // e.preventDefault();
    setLoding(true)
    if(!values.userName ){
        setOpen(true);
        setSeverity('warning');
        setMessage('UserName is Missing');
        reset();
        setLoding(false) 
    }
    else if(!values.password){
        setOpen(true);
        setSeverity('warning');
        setMessage('Password is Missing');
        reset(); 
        setLoding(false)
    }else{
    // Call Authentication service
    // AuthenticationService.executeJwtAuthenticationService().then((response) => {
        setUserSession("Bearer ", values.userName)
        loginAPI();

    // }).catch(error => {
      
        // console.log('catch auth  =>' +data);setLoding(false);
    //     setOpen(true);setSeverity('warning');
    //     setMessage(error.message);
    //     reset();
    //     setLoding(false) 
    // });
}
}


    const loginAPI = () => {
        // var date = new Date();
        // var mnth ='';
        // if((date.getMonth()+1)< 10){
        //      mnth = '0'+(date.getMonth()+1);
        // }else{
        //     mnth = (date.getMonth()+1);
        // }
        // var dte ='';
        // if((date.getDate())< 10){
        //     dte = '0'+(date.getDate());
        // }else{
        //     dte = (date.getDate());
        // }
        // var curDate = date.getFullYear()+''+mnth+''+dte+''+date.getHours()+''+date.getMinutes()+''+date.getSeconds();
        // const data = curDate;
       
        const usernameencrypt = CryptoJS.AES.encrypt(values.userName, "iyyapan").toString();
        const psswordecrypt = CryptoJS.AES.encrypt(values.password, "iyyapan").toString();
            let logindetails = {username:usernameencrypt,password:psswordecrypt};
            LoginServices.getLogin(logindetails).then(res=>{const data=res.data;
                if(res.data[0].message === 'Login Success'){
                    const place =data.map(detail=>detail.placeName);setUserPlaceSession(place);
                    setOpen(true);setSeverity('success');
                    setMessage(res.data[0].message);reset();setLoding(false);
                    setloginSession(res.data[0].userid,res.data[0].currentDate);
                    console.log(res.data[0].currentDate)
                    console.log(res.data)
                    props.history.push('/imports');
                }else{
                    setOpen(true);setSeverity('error');
                    setMessage(res.data[0].message);
                    reset();setLoding(false);
                }
                }).catch(error=>{
                    console.log("l_err "+JSON.stringify(error.message))
                    setOpen(true);
                    setSeverity('error');
                    setMessage(error.message)
                    reset();setLoding(false)
                })

    }
    const reset = () => {
        setValues({
            userName: "",
            password: "",

        })
    }
    const keyDown=(e)=>{
        if(e.key=== 'Enter'){
            login();
        }
      }
      const keyown=(evt)=>{
        if(evt.key === 'Enter'){
        evt.preventDefault(); // if it's inside <form> tag, you don't want to submit it
        document.getElementById('nextInputID').focus();
        }
      }
  const handleClose =()=>{
    setOpen(false);
  }
    const ChangeUsernameHandler = (e) => {
        setValues({ ...values, userName: e.target.value })
    }

    const ChangeUserpasswordHandler = (e) => {
        setValues({ ...values, password: e.target.value })
    }
    return (
        <div className="App-header">
            <center>
               
            <Snackbar open={open} autoHideDuration={9000} onClose={handleClose}>
            <Alert onClose={handleClose} severity={severity}>
               {message}
             </Alert>
            </Snackbar>
                <Paper elevation={9}>
                    <img className="icon" src={ng_pillai} alt="ngPillai"/>
                <h6>Login to continue</h6>
                <Container>
                <Form >
                    <TextField type={'text'}  className={classes.formcontrol} value={values.userName}
                     onChange={ChangeUsernameHandler} label='UserName' onKeyDown={keyown} autoFocus/>
                    <br />
                    <TextField type={'password'}  className={classes.formcontrol} onKeyDown={keyDown}
                     value={values.password} onChange={ChangeUserpasswordHandler} id='nextInputID' label='Password' />
                <br/>
                <Button variant='success' size='small' onClick={login} className={classes.submit} disabled={loding}>{loding ? 'Processing..':'Login'}</Button>
              <br/>
              {/* <Typography variant="caption" display="block" gutterBottom>
        @NGP.Customs.Ltd
      </Typography> */}
      <br/>
                </Form>
                </Container>
                </Paper>
            </center>
        </div>
    )
}
